export default __webpack_public_path__ + "static/media/left-image.062c5223.png";